module.exports = __webpack_public_path__ + "static/media/gallery-5.a712bdc1.jpg";